<template>
	<div>
		
		<b-row class="mt-5">
			<b-col>
				<b-form inline @submit.prevent="searchJobs">
					<b-form-group>
						<b-input type="text" v-model="params.q" />

						<b-button type="submit" variant="outline-success">Search</b-button>

						<b-button v-if="searchFlag" @click.prevent="clearSearch" variant="outline-danger">Clear</b-button>
					</b-form-group>
				</b-form>
			</b-col>

			<b-col class="text-right">
				<b-form-group>
					<b-form-select value-field="Value" text-field="DisplayName" v-model="params.type" :options="jobTypes" @change="searchJobs" class="w-auto mr-3">
						<template #first>
							<b-form-select-option value="">Filter by Type</b-form-select-option>
						</template>
					</b-form-select>
				
					<b-form-select value-field="Id" text-field="Name" v-model="params.jobStatusId" :options="states" @change="searchJobs" class="w-auto">
						<template #first>
							<b-form-select-option value="">Filter by Status</b-form-select-option>
							<!-- <b-form-select-option value="1000">1000k</b-form-select-option> -->
						</template>
						<b-form-select-option value="1000">Needs part invoice</b-form-select-option>
					</b-form-select>
				</b-form-group>
			</b-col>

		</b-row>

		<b-row class="">
			<b-col md="12">

				<b-table-simple bordered>

					<b-thead head-variant="light">
						<tr>
							<th>
								<a href="#" @click.prevent="sort('Id')">
									Job Number
									<b-icon
										class="ml-1"
										icon="caret-up-fill"
										v-if="currentSort == 'Id' && currentSortDir == 'asc'"
									></b-icon>
									<b-icon
										class="ml-1"
										icon="caret-down-fill"
										v-else-if="currentSort == 'Id' && currentSortDir == 'desc'"
									></b-icon>
									<!-- <b-icon font-scale="1" class="ml-1" v-else icon="arrow-up-down"></b-icon> -->
								</a>
							</th>
							<th>
								<a href="#" @click.prevent="sort('Clock.Name')">
									Clock
									<b-icon
										class="ml-1"
										icon="caret-up-fill"
										v-if="currentSort == 'Clock.Name' && currentSortDir == 'asc'"
									></b-icon>
									<b-icon
										class="ml-1"
										icon="caret-down-fill"
										v-else-if="currentSort == 'Clock.Name' && currentSortDir == 'desc'"
									></b-icon>
									<!-- <b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon> -->
								</a>
							</th>
							<th>				
								<a href="#" @click.prevent="sort('Type')">
									Type
									<b-icon
										class="ml-1"
										icon="caret-up-fill"
										v-if="currentSort == 'Type' && currentSortDir == 'asc'"
									></b-icon>
									<b-icon
										class="ml-1"
										icon="caret-down-fill"
										v-else-if="currentSort == 'Type' && currentSortDir == 'desc'"
									></b-icon>
									<!-- <b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon> -->
								</a>
							</th>
											
							<th>
								<a href="#" @click.prevent="sort('Status.Name')">
									Status
									<b-icon
										class="ml-1"
										icon="caret-up-fill"
										v-if="currentSort == 'Status.Name' && currentSortDir == 'asc'"
									></b-icon>
									<b-icon
										class="ml-1"
										icon="caret-down-fill"
										v-else-if="currentSort == 'Status.Name' && currentSortDir == 'desc'"
									></b-icon>
									<!-- <b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon> -->
								</a>
							</th>
							<th>
								<a href="#" @click.prevent="sort('QuotesTotal')">
									Quote value
									<b-icon
										class="ml-1"
										icon="caret-up-fill"
										v-if="currentSort == 'Quote value' && currentSortDir == 'asc'"
									></b-icon>
									<b-icon
										class="ml-1"
										icon="caret-down-fill"
										v-else-if="currentSort == 'Quote value' && currentSortDir == 'desc'"
									></b-icon>
									<!-- <b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon> -->
								</a>
							</th>
							<th>Due</th>
						</tr>
					</b-thead>

					<b-tbody>
						<job-list-row v-for="job in jobs" :key="job.Id" :job="job" :jobTypes="jobTypes" />
					</b-tbody>

				</b-table-simple>
			</b-col>
		</b-row>

		<div class="d-flex justify-content-center mb-5">
			<b-pagination
				first-number
				last-number
				v-model="paging.currentPage"
				:total-rows="paging.totalCount"
				:per-page="paging.pageSize"
				@input="fetchJobs"
				limit="7"
				class="mr-3"
			></b-pagination> 
			<b-form-input
				debounce="1000"
				min="1"
				v-model="paging.currentPage"
				:max="paging.totalPages"
				type="number"
				@input="fetchJobs"
				style="width:100px;"
			></b-form-input>
		</div>
		
	</div>
</template>


<script>
import JobService from '@/api-services/job.service';
import JobListRow from '@/components/job/job-list-row';

export default {
	name: 'JobList',

	components: {
		JobListRow,
	},

	data() {
		return {
			jobs: [],

			states: [],

			jobTypes: [
				{ Value: 0, DisplayName: 'Enquiry' },
				{ Value: 1, DisplayName: 'Problem' },
				{ Value: 2, DisplayName: 'Service' },
				{ Value: 3, DisplayName: 'Job' }
			],

			params: {
				jobStatusId: '',
				type: '',
				q: '',
			},

			currentSort: 'Id',
			currentSortDir: 'asc',

			searchFlag: false,

			paging: {
				currentPage:
					this.$route.query.p == null
						? 1
						: parseInt(this.$route.query.p),
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			}
		};
	},

	created() {
		this.urlReadState();

		this.fetchJobStates();
	},

	methods: {
		sort(s) {
			//if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir =
					this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;

			this.fetchJobs();
		},

		urlReadState() {

			let urlSort = this.$route.query.s;
			let urlSortDir = this.$route.query.d;
			let urlSearch = this.$route.query.q;

			let urlStatus = this.$route.query.s;
			let urlType = this.$route.query.t;

			if (urlSort || urlSortDir) {

				this.currentSortDir = (urlSortDir === undefined) ? '' : urlSortDir;
				this.currentSort = urlSort; (urlSort === undefined) ? this.currentSort : urlSort;
			}

			if (urlSearch || urlStatus || urlType) {

				this.params.q = (urlSearch === undefined) ? '' : urlSearch;
				this.params.jobStatusId = (urlStatus === undefined) ? '' : urlStatus;
				this.params.type = (urlType === undefined) ? '' : urlType;

				this.searchJobs();
			} else {

				this.fetchJobs();
			}
		},

		urlPushState() {
			if (history.pushState) {

				const urlParams = new URLSearchParams(window.location.search);

				if (this.paging.currentPage > 1) {
					urlParams.set('p', this.paging.currentPage);

				} else {
					urlParams.delete('p');
				}

				if (this.currentSort != 'Id') {
					urlParams.set('s', this.currentSort);
				} else {
					urlParams.delete('s');
				}

				if (this.currentSortDir != 'asc') {
					urlParams.set('d', this.currentSortDir);
				} else {
					urlParams.delete('d');
				}

				if (this.params.q != '') {
					urlParams.set('q', this.params.q);

				} else {
					urlParams.delete('q');
				}

				if (this.params.jobStatusId !== '') {
					urlParams.set('s', this.params.jobStatusId);
				} else {
					urlParams.delete('s');
				}

				if (this.params.type !== '') {
					urlParams.set('t', this.params.type);
				} else {
					urlParams.delete('t');
				}

				let origin = new URLSearchParams(window.location.search);

				if (JSON.stringify(Array.from(urlParams)) !== JSON.stringify(Array.from(origin))) {
					var newurl =
						window.location.protocol +
						'//' +
						window.location.host +
						window.location.pathname +
						'?' +
						urlParams;
					window.history.pushState({ path: newurl }, '', newurl);
				}
			}
		},


		resetPaging() {
			this.paging = {
				currentPage: 1,
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			};
		},

		clearSearch() {
			if (this.searchFlag) {
				this.params.q = '';
				this.searchFlag = false;
				this.resetPaging();
				this.fetchJobs();
			}
		},

		jobQuery() {
			var esc = encodeURIComponent;
			return Object.keys(this.params)
				.map((k) => esc(k) + '=' + esc(this.params[k]))
				.join('&');
		},

		searchJobs() {
			
			if (this.params.q != '' || this.params.jobStatusId !== '' || this.params.type !== '') {
				this.resetPaging();


				if (this.params.jobStatusId == '1000') {

					this.params.jobStatusId = 1000;

					

				}
				let jobQuery = this.jobQuery();

				

				JobService.search(jobQuery).then((response) => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers['paging-headers'])
					);

					this.jobs = response.data;

					this.urlPushState();


					this.searchFlag = true;


				});
			}
		},

		fetchJobs() {
			JobService.getPaged(
				this.paging.pageSize,
				this.paging.currentPage,
				this.currentSort,
				this.currentSortDir
			)
				.then((response) => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers['paging-headers'])
					);

					this.jobs = response.data;

					this.urlPushState();
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},

		fetchJobStates() {
			JobService.getStates()
				.then((response) => {
					this.states = response.data;
				})
				.catch((error) => {
					console.log('not authorized');
				});
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/job/job-list.vue